import {render} from 'inferno';
import {document} from './util';

import type {VNode} from 'inferno';

const classname = 'dynamic';

function addElement(node: VNode|VNode[], context: jsx.AppGlobals) {
    if (Array.isArray(node)) {
        for (const child of node) {
            addElement(child, context);
        }
        return;
    }
    if (!node || !Object.prototype.hasOwnProperty.call(node, 'type')) {
        return;
    }
    if (node.type === null) {
        return;
    }
    node.className = classname;
    context.response.htmlMetadata.push(node);
}

export function Metadata(props: jsx.Props, context: jsx.AppGlobals) {
    props.children = props.children ? props.children : [];
    props.children = Array.isArray(props.children) ?
        props.children : [props.children];

    let head: Element|null = null;
    if (process.env.BROWSER) {
        head = document.getElementsByTagName('head')[0];
    }
    // Remove added elements.

    // We have to expose this on the context for the ssr-common code to
    // have access.
    context.response.htmlMetadata = [];
    if (head) {
        const els: HTMLCollection = head.getElementsByClassName(classname);
        // Using `Array.from` shouldn't be necessary, but is:
        // https://github.com/zloirock/core-js/issues/37
        for (const el of Array.from(els)) {
            el.remove();
        }
    }

    const page = props.page;
    // Standard page metadata
    const defaultMetadata = [
        <title>{page.title || ''}</title>,
        <link rel="canonical" href={page.canonicalURL || ''}/>,
        <meta name="keywords" content={page.keywords || ''}/>,
        <meta name="description" content={page.description || page.title || ''}/>,
        <meta name="twitter:title" content={page.title || ''}/>,
        <meta name="twitter:description" content={page.description || page.title || ''}/>,
        <meta name="twitter:site" content="@gifkeyboard"/>,
        <meta name="twitter:app:name:iphone" content="GIF Keyboard"/>,
        <meta name="twitter:app:name:ipad" content="GIF Keyboard"/>,
        <meta name="twitter:app:name:googleplay" content="GIF Keyboard"/>,
        <meta name="twitter:app:id:iphone" content="917932200"/>,
        <meta name="twitter:app:id:ipad" content="917932200"/>,
        <meta name="twitter:app:id:googleplay" content="com.riffsy.FBMGIFApp"/>,
        <meta property="al:ios:app_name" content="GIF Keyboard" />,
        <meta property="al:ios:app_store_id" content="917932200" />,
        <meta property="al:android:package" content="com.riffsy.FBMGIFApp" />,
        <meta property="al:android:app_name" content="GIF Keyboard" />,
        <meta property="fb:app_id" content="374882289330575"/>,
        <meta property="og:site_name" content="Tenor"/>,
        <meta property="og:title" content={page.title || ''}/>,
    ];
    if (page.noindex) {
        defaultMetadata.push(<meta name="robots" content="noindex"/>);
    }
    if (!this.props.hideIOSUpsell) {
        defaultMetadata.push(<meta name="apple-itunes-app" content={`app-id=917932200,app-argument=${page.canonicalURL || ''}`}/>);
    }
    addElement(defaultMetadata, context);

    // Add new elements.
    // props.children is declared as InfernoNode but it's actually VNode[].
    addElement(props.children as VNode[], context);

    if (process.env.BROWSER) {
        // Doing this instead of importing inferno-server's `renderToString`
        // reduces our final, minified build size by ~15kb.
        const element = document.createElement('div');
        let metadataStr = '';

        for (const item of context.response.htmlMetadata) {
            render(item, element);
            metadataStr += element.innerHTML;
        }
        head.insertAdjacentHTML('beforeend', metadataStr);
    }
    return null;
}
